/*!
 * Copyright © 2019-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef } from '@angular/core';
import { isElementNull } from '../../../../utils';

import {
  IHarshDrivingEventBalloon,
  IUserPermissions,
  EPermissionStatus,
  EHarshDrivingEventClassification,
  IUserSettings
} from '../../../core/models';

@Component({
  selector: 'fm-harsh-driving-event-balloon',
  templateUrl: './harsh-driving-event-balloon.component.html',
  styleUrls: ['./harsh-driving-event-balloon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HarshDrivingEventBalloonComponent {
  @Input()
  balloon: IHarshDrivingEventBalloon;
  @Input()
  permissions: IUserPermissions;
  @Input()
  userSettings: IUserSettings;

  @Output()
  backToVideoClicked = new EventEmitter<IHarshDrivingEventBalloon>();
  @Output()
  directionsClicked = new EventEmitter<IHarshDrivingEventBalloon>();
  @Output()
  findNearestClicked = new EventEmitter<IHarshDrivingEventBalloon>();
  @Output()
  replayClicked = new EventEmitter<IHarshDrivingEventBalloon>();

  EHarshDrivingEventClassification = EHarshDrivingEventClassification;
  EPermissionStatus = EPermissionStatus;
  showSubMenu = false;

  @ViewChild('subMenu', { read: ElementRef })
  private readonly _subMenuElement: ElementRef;
  @ViewChild('subMenuTrigger', { read: ElementRef })
  private readonly _subMenuTriggerElement: ElementRef;

  @HostListener('document:touchstart', ['$event'])
  public documentTouch(event: any): void {
    if ((window as any).TouchEvent) {
      this.checkDocumentTouchOrClick(event);
    }
  }

  @HostListener('document:mousedown', ['$event'])
  public documentClick(event: MouseEvent): void {
    this.checkDocumentTouchOrClick(event);
  }

  public checkDocumentTouchOrClick(event: any): void {
    if (
      this.showSubMenu &&
      !isElementNull(this._subMenuTriggerElement) &&
      !this._subMenuTriggerElement.nativeElement.contains(event.target) &&
      !isElementNull(this._subMenuElement) &&
      !this._subMenuElement.nativeElement.contains(event.target)
    ) {
      this.showSubMenu = false;
    }
  }

  onBackToVideo(): void {
    this.backToVideoClicked.emit(this.balloon);
    this.showSubMenu = false;
  }

  onDirections(): void {
    this.directionsClicked.emit(this.balloon);
  }

  onFindNearest(): void {
    this.findNearestClicked.emit(this.balloon);
  }

  onReplay(): void {
    this.replayClicked.emit(this.balloon);
    this.showSubMenu = false;
  }
}
